@if (isReportLoading$ | async) {
  <nk-spinner display="inline" [attr.data-cy]="'global-report-loading'"></nk-spinner>
}
<div class="report-view">
  @if (reportTitlePageData$ | async; as reportTitlePageData) {
    <nk-report-title-page
      class="page-break-after d-flex"
      [reportTitlePageData]="reportTitlePageData"></nk-report-title-page>
  }
  <div class="page-break-after" [attr.data-cy]="'screening-case-information'">
    <nk-screening-entity-screening-cases
      [screeningConfigUuid]="screeningConfigUuid"
      [screeningEntityUuid]="screeningEntityUuid"
      [printView]="true"></nk-screening-entity-screening-cases>
  </div>
</div>
